exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.userInfo {\r\n\tpadding: 0px;\r\n\tposition: relative;\r\n\tfloat: right;\n}\n.userInfoLabel {\r\n\tbackground-color: #4a90e2 !important;\r\n\tborder-left: 5px #4a90e2 !important;\r\n\tcolor: #fff !important;\r\n\tfont-size: 12px;\r\n\t/* font-weight: bold; */\r\n\ttext-align: left;\r\n\tmargin: 10px 0 !important;\n}\r\n", ""]);

// exports
